// export const baseUrl = "http://localhost:9000/api";
// export const baseUrl = 'http://13.127.223.104/api'
export const baseUrl = "https://www.thasya.tech/api";

// export const baseUrl ='https://saloon-crm-backend.vercel.app/api'
